import React, { useContext } from "react";
import {
  DropdownMenuItem,
  DropdownMenuItemType,
} from "../../../../components/DropdownMenu";
import Icon, { IconType } from "../../../../components/Icon";
import { UserUrls } from "../../../UserManagement";
import UserParent from "../../../UserManagement/UserNew/util/UserParent";
import Permission from "../../../../Authentication/model/Permission";
import PermissionArea from "../../../../Authentication/model/PermissionArea";
import CreateAuditScheduleLocationProps from "../../../../Models/AuditProps/CreateAuditScheduleLocationProps";
import { AuditUrls } from "../../../AuditManagement";
import { SiteUrls } from "../../index";
import { EntityTypeContext } from "../../../../routing/GenericRoutes";
import { isCBUser, isCompanyUser } from "../../../../Authentication/Auth";

export default (id: string, name: string = ""): DropdownMenuItem[] => {
  const state: CreateAuditScheduleLocationProps = {
    site: {
      id: +id,
      name,
    },
  };
  const typeUrls = useContext(EntityTypeContext)?.urls;
  if (!typeUrls || !id) return [];
  var createUserItem : DropdownMenuItem = 
    {
      icon: <Icon type={IconType.USER_ADD} />,
      label: "Create User",
      type: DropdownMenuItemType.LINK,
      link: UserUrls.create({ [UserParent.SITE]: id }),
      permissionRequired: [
        {
          permission: Permission.GENERATE,
          area: PermissionArea.USER,
        },
      ],
    };
  var menuItems : DropdownMenuItem[] = [    
    {
      icon: <Icon type={IconType.USERS} />,
      label: "View Users",
      type: DropdownMenuItemType.LINK,
      state: { name },
      link: SiteUrls.users(id),
      permissionRequired: [
        {
          permission: Permission.VIEW,
          area: PermissionArea.USER,
        },
      ],
    },
    {
      icon: <Icon type={IconType.SCHEDULE} />,
      label: "Audit Schedule",
      type: DropdownMenuItemType.LINK,
      state,
      link: AuditUrls.scheduleSite(id),
      permissionRequired: [
        {
          area: PermissionArea.AUDIT,
          permission: Permission.SCHEDULE,
        },
      ],
    },
    {
      icon: <Icon type={IconType.Settings} />,
      label: "Verify Settings",
      type: DropdownMenuItemType.LINK,
      state,
      link: typeUrls.share(id)+"/verify-settings",
      permissionRequired: [
        {
          permission: Permission.VIEW,
          area: PermissionArea.USER,
        },
      ],
    },
  ];
  if(isCBUser() || isCompanyUser()) return menuItems;
  else return [createUserItem, ...menuItems];
};
